import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowRight, Clock, CheckCircle, MessageSquare, ClipboardCheck, Sparkles } from 'lucide-react';

export const WhyCABPreview = () => {
  const reasons = [
    {
      icon: Clock,
      title: 'We Finish What We Start — On Schedule',
      description: 'Written timeline on every project. Milestone sign-offs. Proactive communication. We show up when we say we will.',
    },
    {
      icon: Sparkles,
      title: 'Detail Work That Actually Shows',
      description: 'Every phase hits our quality bar before we move forward. No shortcuts. No cut corners.',
    },
    {
      icon: MessageSquare,
      title: 'One Point of Contact. Zero Runaround.',
      description: 'We handle all trades under one roof. You get updates from your dedicated project manager, not a rotating cast.',
    },
  ];

  return (
    <section data-testid="why-cab-preview" className="py-24 bg-warm-accent">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left - Content */}
          <div className="space-y-8">
            <div>
              <span className="text-copper text-xs font-inter uppercase tracking-widest">
                Why C.A.B
              </span>
              <h2 className="text-4xl md:text-5xl font-playfair font-bold text-navy mt-4 leading-tight">
                Why homeowners choose us
              </h2>
            </div>

            <div className="space-y-6">
              {reasons.map((reason, index) => (
                <div 
                  key={index} 
                  className="flex space-x-4 group"
                  data-testid={`why-reason-${index}`}
                >
                  <div className="w-12 h-12 bg-navy/10 flex items-center justify-center flex-shrink-0 group-hover:bg-copper/20 transition-colors">
                    <reason.icon className="w-5 h-5 text-copper" />
                  </div>
                  <div>
                    <h3 className="font-playfair font-semibold text-navy text-lg">
                      {reason.title}
                    </h3>
                    <p className="text-navy/60 font-inter text-sm mt-1 leading-relaxed">
                      {reason.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            <Link to="/process">
              <Button 
                data-testid="why-cab-cta"
                className="bg-copper hover:bg-copper/90 text-white px-8 py-6 text-xs font-bold uppercase tracking-widest group"
              >
                See Our Process
                <ArrowRight className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform" />
              </Button>
            </Link>
          </div>

          {/* Right - Process Steps */}
          <div className="bg-white p-8 lg:p-12 border border-tan/20">
            <h3 className="font-playfair font-bold text-navy text-2xl mb-8">
              Our 4-Step Process
            </h3>
            <div className="space-y-6">
              {[
                { step: 1, title: '$49.99 Estimate & Site Walk' },
                { step: 2, title: 'Signed Proposal with Written Timeline' },
                { step: 3, title: 'Work Begins — With Updates Built In' },
                { step: 4, title: 'Completion' },
              ].map((item, index) => (
                <div 
                  key={index}
                  className="flex items-center space-x-4"
                  data-testid={`process-step-${item.step}`}
                >
                  <div className="w-10 h-10 bg-navy text-white font-playfair font-bold flex items-center justify-center text-sm">
                    {item.step}
                  </div>
                  <span className="font-inter text-navy">{item.title}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyCABPreview;
